import React, { Component } from 'react';
import { withRouter, Link } from 'react-router-dom';
import { connect } from 'react-redux';

import FacebookLogin from 'react-facebook-login';

import CircularProgress from '@material-ui/core/CircularProgress';
import Button from '@material-ui/core/Button';

import Layout from '../../main/components/Layout';
import Alert from '../../common/components/Alert';
import * as authActions from '../actions';

import classes from '../../css/getCSS';
import * as constants from '../../config/constants';

class FBCallback extends Component {
  responseFacebook = (response) => {
    this.props.doSocialLogin(
      'facebook',
      response,
      this.props.site.id,
      this.props.token,
      true,
      this.props.history.location.search.includes('isSignup=1'),
    );
  }

  render() {
    let display = (
      <div align="center">
        <CircularProgress align="center" size={50} />
        <FacebookLogin
          appId={constants.FB_APP_ID}
          autoLoad
          fields="name,email,picture"
          version="2.3"
          scope="public_profile,email"
          callback={this.responseFacebook}
          cssClass={classes.hidden}
          returnScopes
        />
      </div>
    );

    if (this.props.errors.length > 0) {
      const errors = this.props.errors.map((error, i) => {
        return (<Alert key={i} type="danger"><span dangerouslySetInnerHTML={{ __html: error }} /></Alert>); // eslint-disable-line
      });
      display = (
        <div align="center">
          {errors}
          <br />
          <Link className={classes.linkDeCSS} to="/"><Button variant="contained" color="primary">Back to Home</Button></Link>
        </div>
      );
    }

    return (
      <Layout hideNavbar rootClass={classes.loginBack} background>
        {display}
      </Layout>
    );
  }
}


const mapStateToProps = (state) => {
  return {
    site: state.common.site,
    loading: state.auth.loading,
    hasError: state.auth.hasError,
    errors: state.auth.errors,
    token: state.auth.token,
    isAuthenticated: state.auth.token !== null,
  };
};


const mapDispatchToProps = (dispatch) => {
  return {
    doSocialLogin: (type, response, siteID, token, fbcallback, isSignup) => dispatch(
      authActions.doSocialLogin(type, response, siteID, token, fbcallback, isSignup),
    ),
  };
};

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(FBCallback));



// WEBPACK FOOTER //
// ./src/auth/containers/FBCallback.js